import React from "react";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { IExtractImageModel } from "../../types/manualFinder";
import DisplayMatchedImages from "./MatchedImages";
import { FeedbackButtons } from "../FeedbackButtons/FeedbackButtons";


interface IImageCardProps {
    imageSet: IExtractImageModel;
    index: number,
    createDropFileObject: (index: number) => void;
    onClickFeedback: (isUseful: boolean, id: any) => Promise<void>
    onClickRefresh: (index: number) => Promise<void>;
    reloadTaImages: boolean[]
}

const ImageCard: React.FC<IImageCardProps> = ({
    imageSet,
    index,
    createDropFileObject,
    onClickFeedback,
    onClickRefresh,
    reloadTaImages
}) => {
    const { t } = useTranslation();

    return (
        <Row key={imageSet.parentKeyName} className="mb-4">
            <Col md={4} className="d-flex align-items-stretch">
                <Card className="w-100 h-100 card-color d-flex flex-column image-card">
                    <Card.Body className="d-flex flex-column" style={{ flex: 1 }}>
                        <Row className="d-flex justify-content-between" style={{ flex: 1 }}>
                            <Col md={12} className="d-flex flex-column">
                                <Card.Title>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="flex-grow-1 text-center">
                                            {t("ExtractedImages.PDFImage").replace(
                                                "{}",
                                                (index + 1).toString()
                                            )}
                                        </div>
                                        <Button
                                            className="me-2 text-align-center d-flex align-items-center justify-content-center drop-file-button"
                                            variant="secondary"
                                            onClick={() =>
                                                createDropFileObject(index)
                                            }
                                        >
                                            <FontAwesomeIcon icon={faExternalLinkAlt} />{" "}
                                        </Button>
                                    </div>
                                </Card.Title>
                                <Card className="d-flex flex-column justify-content-center" style={{ flex: 1 }}>
                                    <Card.Img className="image" src={imageSet.parentImage} alt={`Parent ${index}`} />
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                    <FeedbackButtons imageSet={imageSet} onClickFeedback={onClickFeedback} />
                </Card>
            </Col>

            <Col md={8}>
                <Card className="h-100 image-card">
                    <Card.Body>
                        <Card.Title>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="flex-grow-1">
                                    {t("ExtractedImages.MatchedImages")}
                                </div>
                                {reloadTaImages[index] ? (
                                    <Spinner animation="border" role="status" className="me-1"
                                        style={{ width: "1rem", height: "1rem" }}></Spinner>
                                ) :
                                    <>
                                        <Button
                                            className="me-2 text-align-center d-flex align-items-center justify-content-center"
                                            variant="secondary"
                                            onClick={() => onClickRefresh(index)}
                                        ><FontAwesomeIcon icon={faRefresh} />{""}</Button></>
                                }
                            </div>
                        </Card.Title>
                        <Row className="d-flex justify-content-between">
                            <DisplayMatchedImages
                                oemImageName={imageSet.parentKeyName}
                                matches={imageSet.matches}
                            />
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}
    ;

export default ImageCard;
